import { useEffect, useState } from 'react'
import { useFormContext } from 'react-hook-form'

import { ObjectFieldDTO } from '@types'

type ValueTypeOfSelectedValueOptions = {
  objectField: ObjectFieldDTO | undefined
  valueTypeInputName: string
}

export const useValueTypeOfSelectedValue = ({
  objectField,
  valueTypeInputName,
}: ValueTypeOfSelectedValueOptions) => {
  const { setValue } = useFormContext()
  const [selectedValueType, setSelectedValueType] = useState('')

  useEffect(() => {
    if (objectField?.valueType) {
      setSelectedValueType(objectField.valueType as string)
      setValue(valueTypeInputName, objectField.valueType as string)
    }
  }, [objectField])

  return { selectedValueType, setSelectedValueType }
}
